import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { InvoiceApi, InvoiceDataType } from "@/api/InvoiceApi";
import { useAppSelector } from "@/store/hooks";
import { ShippingGuidePages } from "@components/print/PrintElements/ShippingGuide";
import { PrintPageDataLoadedPubSub } from "@utils/pubsubs/PubSub";

/**
 * Reimpresion de la guia de envio de una factura ya emitida. Se llega aqui desde la lista de
 * facturas; la guia que sale justo despues de facturar la agrega la ruta de impresion de la
 * factura, pero ambas montan el mismo `ShippingGuidePages`.
 */
const InvoiceShippingGuide = () => {
  const { id: invoiceId, autoPrint = false } = useParams();
  const suscription = useAppSelector((state) => state.suscription.suscription);
  const [invoice, setInvoice] = useState<InvoiceDataType>({});

  useEffect(() => {
    import("@printerVariation/generic.scss");
    PrintPageDataLoadedPubSub.publish({ dataLoaded: false });
    loadInvoiceData();
  }, []);

  const loadInvoiceData = async () => {
    if (invoiceId) {
      // selectionSet acotado: la guia no muestra lineas, montos ni datos fiscales.
      const invoice = await InvoiceApi.get(invoiceId, {
        selectionSet: [
          "id", "numero", "bultos", "shipping_carrier",
          "nombre_factura", "direccion", "tel1", "tel2"
        ]
      });
      setInvoice(invoice);
    }
    PrintPageDataLoadedPubSub.publish({ dataLoaded: true });
  }

  if (!invoice?.id) {
    return (<h3> Cargando </h3>);
  }

  if (Number(invoice.bultos || 0) <= 0) {
    return (<h3> Esta factura no tiene guia de envio </h3>);
  }

  return (
    <ShippingGuidePages
      invoice={invoice}
      suscription={suscription}
      autoPrint={autoPrint === "1"}
    />
  );
}

export default InvoiceShippingGuide;
